import { defineComponent as j, useModel as L, computed as w, openBlock as o, createElementBlock as h, normalizeClass as u, createVNode as R, unref as b, withCtx as m, createBlock as f, createTextVNode as $, toDisplayString as g, createCommentVNode as x, createElementVNode as n, Fragment as N, renderList as G, mergeModels as M } from "vue";
import O from "./index9.js";
import U from "./index60.js";
import { RadioGroup as E, RadioGroupLabel as F, RadioGroupOption as W } from "./index275.js";
const S = ["disabled"], T = { class: "inline-flex max-w-full items-center gap-x-1.5" }, q = { class: "block max-w-[115px] overflow-hidden text-ellipsis whitespace-nowrap" }, J = /* @__PURE__ */ j({
  __name: "BaseRadioGroup",
  props: /* @__PURE__ */ M({
    options: { default: () => [] },
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    name: { default: "" },
    by: {},
    fullwidth: { type: Boolean, default: !1 },
    noUnderline: { type: Boolean, default: !1 },
    allowedList: { default: void 0 },
    scrollable: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const t = l, p = L(l, "modelValue"), y = w(() => {
      const a = t.scrollable;
      return t.variant === "underline" ? a ? "flex w-full min-w-max flex-nowrap" : t.fullwidth ? "flex w-full" : "flex flex-nowrap" : a ? "bg-neutral-neutral050 flex w-full min-w-max flex-nowrap gap-x-[5px] rounded-[6px] py-1 px-1" : "bg-neutral-neutral050 flex gap-x-[5px] rounded-[6px] py-1 px-1";
    }), C = w(
      () => t.scrollable ? "w-full min-w-0 overflow-x-auto overflow-y-hidden" : ""
    ), k = (a, r = !1, e = !1) => {
      const c = t.fullwidth, s = `focus:outline-none focus:ring-0 flex items-center gap-x-2 ${t.scrollable ? "flex-shrink-0" : ""} ${c ? "flex-1 justify-center" : ""}`.trim();
      if (t.variant === "underline") {
        if (e) {
          const B = t.size === "sm" ? "px-4 py-3 text-sm font-medium" : "py-3 px-6 text-base font-semibold";
          return [
            s,
            "opacity-50 cursor-not-allowed",
            B,
            "text-default-muted-dark"
          ].join(" ");
        }
        const _ = t.size === "sm" ? "px-4 py-3 text-sm font-medium" : "py-3 px-6 text-base font-semibold", z = a ? "bg-bg-bg-default text-default font-semibold" : "bg-bg-bg-default text-default-muted-dark", V = a ? t.size === "sm" ? "shadow-[inset_0_-2px_0_0_var(--input-color-border-focus)]" : "shadow-[inset_0_-3px_0_0_var(--input-color-border-focus)]" : t.noUnderline ? "" : t.size === "sm" ? "shadow-[inset_0_-1px_0_0_var(--background-bg-outline)]" : "shadow-[inset_0_-2px_0_0_var(--background-bg-outline)]";
        return [s, "whitespace-nowrap", _, z, V].filter(Boolean).join(" ");
      }
      const i = t.size === "sm" ? "h-[28px]" : "h-[34px]", d = `${s} justify-center ${i} px-3 text-[13px] leading-[16px] tracking-tight rounded-xs transition-colors duration-200 whitespace-nowrap`;
      return e ? [
        d,
        "opacity-50 cursor-not-allowed text-[var(--button-tab-text-off)]"
      ].join(" ") : a ? [
        d,
        "bg-[var(--button-tab-button-on)] text-[var(--button-tab-text-on)] font-semibold"
      ].join(" ") : r ? [
        d,
        "bg-[var(--button-tab-button-hover)] text-[var(--button-tab-text-on)]"
      ].join(" ") : [
        d,
        "text-[var(--button-tab-text-off)] hover:bg-[var(--button-tab-button-hover)] hover:text-[var(--button-tab-text-on)]"
      ].join(" ");
    };
    return (a, r) => (o(), h("div", {
      class: u(["w-full", { "min-w-0": l.scrollable }])
    }, [
      R(b(E), {
        modelValue: p.value,
        "onUpdate:modelValue": r[0] || (r[0] = (e) => p.value = e),
        disabled: l.disabled,
        name: l.name,
        by: l.by,
        class: "space-y-2"
      }, {
        default: m(() => [
          l.label ? (o(), f(b(F), {
            key: 0,
            class: "block text-sm font-medium text-[var(font-color-default)]"
          }, {
            default: m(() => [
              $(g(l.label), 1)
            ]),
            _: 1
          })) : x("", !0),
          n("div", {
            class: u(C.value)
          }, [
            n("div", {
              class: u(y.value)
            }, [
              (o(!0), h(N, null, G(l.options, (e, c) => (o(), f(b(W), {
                key: e.value,
                value: e.value,
                disabled: e.disabled || l.disabled || l.allowedList !== void 0 && !l.allowedList.includes(c),
                as: "template"
              }, {
                default: m(({ checked: v, active: s, disabled: i }) => [
                  n("button", {
                    class: u(k(v, s, i)),
                    disabled: i,
                    type: "button"
                  }, [
                    e.icon ? (o(), f(U, {
                      key: 0,
                      name: e.icon,
                      className: "h-4 w-4"
                    }, null, 8, ["name"])) : x("", !0),
                    n("span", T, [
                      n("span", q, g(e.label), 1),
                      e.chipLabel ? (o(), f(O, {
                        key: 0,
                        label: e.chipLabel,
                        variant: e.chipVariant || "grey",
                        size: "sm",
                        rounded: e.chipRounded || "rounded-full",
                        fontWeight: "font-medium"
                      }, null, 8, ["label", "variant", "rounded"])) : x("", !0)
                    ])
                  ], 10, S)
                ]),
                _: 2
              }, 1032, ["value", "disabled"]))), 128))
            ], 2)
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "name", "by"])
    ], 2));
  }
});
export {
  J as default
};
